/* BB Collection page behaviour (sections/bb-collection.liquid), 2 Oct 2026.
   Delivery line, sticky toolbar offset, filter drawer, sort, shelf "Show all",
   "Show more products". Also drives the delivery line on the coffee pages
   ([data-bbx-delivery] inside sections/bb-collection-main.liquid).

   DELIVERY LINE (UAE visitors only; elsewhere the server text from
   snippets/bb-delivery.liquid stays as it is). Rule from the shipping policy:
   free across the UAE, orders before 11:00 Gulf time on a working day
   (Monday to Friday) arrive the next working day. After the cut-off, or on a
   weekend, the order is processed on the next working day and arrives the
   working day after that. Public holidays are not known to the page. */
(function () {
  'use strict';
  if (window.__bbxInit) return;
  window.__bbxInit = true;

  var AR = (document.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var DAYS = AR ? ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'] : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  var MONTHS = AR ? ['يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو', 'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'] : ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var CUTOFF_H = 11;

  /* Gulf time as a Date whose UTC fields read as Gulf wall-clock time */
  function gulfNow() { return new Date(Date.now() + 4 * 3600 * 1000); }
  function isBiz(d) { var w = d.getUTCDay(); return w >= 1 && w <= 5; }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function dayStart(d) { return new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate())); }
  function nextBiz(d) { var x = addDays(dayStart(d), 1); while (!isBiz(x)) x = addDays(x, 1); return x; }
  function fmt(d) {
    return AR ? DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()]
              : DAYS[d.getUTCDay()] + ' ' + d.getUTCDate() + ' ' + MONTHS[d.getUTCMonth()];
  }
  function deliveryText() {
    var now = gulfNow();
    var today = dayStart(now);
    var cutoff = new Date(today.getTime() + CUTOFF_H * 3600000);
    var before = isBiz(now) && now < cutoff;
    var processing = before ? today : nextBiz(now);
    var arrive = nextBiz(processing);
    var tomorrow = addDays(today, 1).getTime() === arrive.getTime();
    var when = (tomorrow ? (AR ? 'غداً، ' : 'tomorrow, ') : '') + fmt(arrive);
    if (before) {
      var mins = Math.max(1, Math.ceil((cutoff - now) / 60000));
      var h = Math.floor(mins / 60), m = mins % 60;
      var left = AR ? ((h ? h + 'س ' : '') + m + 'د') : ((h ? h + 'h ' : '') + m + 'm');
      return AR ? 'اطلب خلال <b>' + left + '</b> للتوصيل المجاني ' + when
                : 'Order in <b>' + left + '</b> for free delivery ' + when;
    }
    return AR ? 'اطلب الآن للتوصيل المجاني ' + when : 'Order now for free delivery ' + when;
  }
  function paintDelivery() {
    document.querySelectorAll('[data-bbx-delivery]:not([data-static])').forEach(function (el) {
      var t = el.querySelector('[data-bbx-delivery-text]') || el;
      t.innerHTML = deliveryText();
    });
  }

  /* sticky toolbar: sit under whatever header is showing */
  var bars = [];
  var ticking = false;
  function headerBottom() {
    var max = 0;
    document.querySelectorAll('#header-group, .header-section, header-component, .shopify-section-group-header-group').forEach(function (h) {
      var cs = getComputedStyle(h);
      if (cs.position !== 'sticky' && cs.position !== 'fixed') return;
      var r = h.getBoundingClientRect();
      if (r.height > 0 && r.bottom > max && r.top <= 1) max = r.bottom;
    });
    return Math.max(0, Math.round(max));
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var top = headerBottom();
      bars.forEach(function (b) {
        b.root.style.setProperty('--bbx-top', top + 'px');
        var r = b.bar.getBoundingClientRect();
        var pw = document.querySelector('.page-wrapper');
        var sc = window.scrollY || (pw ? pw.scrollTop : 0);
        b.bar.classList.toggle('is-stuck', r.top <= top + 1 && sc > 0);
      });
    });
  }

  /* filter drawer */
  var lastFocus;
  function openDrawer(d) {
    lastFocus = document.activeElement;
    d.hidden = false;
    requestAnimationFrame(function () { d.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    var card = d.querySelector('.bbx-drawer-card');
    if (card) card.focus({ preventScroll: true });
  }
  function closeDrawer(d) {
    d.classList.remove('is-open');
    setTimeout(function () { d.hidden = true; }, 180);
    document.documentElement.style.removeProperty('overflow');
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  }

  /* show more products (page 2+ appended in place; numbered links stay as the no-JS path) */
  function loadMore(btn) {
    var root = btn.closest('[data-bbx]');
    var grid = root && root.querySelector('[data-bbx-grid]');
    if (!grid) return;
    btn.setAttribute('aria-busy', 'true');
    fetch(btn.href, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var other = doc.getElementById(root.id) || doc.querySelector('[data-bbx]');
        if (!other) throw new Error('no grid');
        other.querySelectorAll('[data-bbx-grid] > [data-bbx-item]').forEach(function (cell) {
          grid.appendChild(document.importNode(cell, true));
        });
        var next = other.querySelector('[data-bbx-next]');
        if (next) { btn.href = next.getAttribute('href'); btn.removeAttribute('aria-busy'); }
        else { btn.remove(); }
        var pages = root.querySelector('.bbx-pages');
        var newPages = other.querySelector('.bbx-pages');
        if (pages && newPages) pages.innerHTML = newPages.innerHTML;
        document.dispatchEvent(new CustomEvent('bbx:appended'));
      })
      .catch(function () { window.location.href = btn.href; });
  }

  function init() {
    document.querySelectorAll('[data-bbx]').forEach(function (root) {
      var bar = root.querySelector('[data-bbx-bar]');
      if (bar) bars.push({ root: root, bar: bar });
    });
    paintDelivery();
    setInterval(paintDelivery, 30000);
    if (bars.length) {
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      window.addEventListener('resize', onScroll);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var opener = t.closest('[data-bbx-open-filters]');
    if (opener) {
      var d = document.getElementById(opener.getAttribute('aria-controls'));
      if (d) { e.preventDefault(); openDrawer(d); }
      return;
    }
    var drawer = t.closest('[data-bbx-drawer]');
    if (drawer && (t === drawer || t.closest('[data-bbx-close]'))) {
      e.preventDefault();
      closeDrawer(drawer);
      return;
    }
    var more = t.closest('[data-bbx-more]');
    if (more) {
      var shelf = more.closest('[data-bbx-shelf]');
      var open = !shelf.classList.contains('is-open');
      shelf.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.textContent = open ? more.getAttribute('data-open') : more.getAttribute('data-closed');
      if (!open) shelf.scrollIntoView({ block: 'start' });
      return;
    }
    var next = t.closest('[data-bbx-next]');
    if (next) { e.preventDefault(); loadMore(next); }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('[data-bbx-sort]');
    if (sel && sel.form) sel.form.submit();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-bbx-drawer].is-open').forEach(closeDrawer);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
